export default class ReportsService {
  constructor(axiosIns, serviceConfig) {
    this.axiosIns = axiosIns;
    this.serviceConfig = serviceConfig;
  }

  getAllActivityReport(args) {
    return this.axiosIns.get(`${this.serviceConfig.reportService}/operation-activity-summary`, {
      params: args
    });
  }

  getAllIncomeExpenseReport(args) {
    return this.axiosIns.get(`${this.serviceConfig.reportService}/revenue-expense`, {
      params: args
    });
  }

  getAllQuantityReport(args) {
    return this.axiosIns.get(`${this.serviceConfig.reportService}/domestic-yearly-shipment-count`, {
      params: args
    });
  }

  uploadProviderBilling(providerName, formData) {
    return this.axiosIns.post(
      `${this.serviceConfig.reconciliationService}/provider/${providerName}/provider-billings`,
      formData,
      {}
    );
  }

  getProviderBillings(args) {
    return this.axiosIns.get(`${this.serviceConfig.reconciliationService}/provider-billings`, {
      params: args
    });
  }

  deleteProviderBilling(id) {
    return this.axiosIns.delete(
      `${this.serviceConfig.reconciliationService}/provider-billings/${id}`
    );
  }

  getReconciliationProviders(args) {
    return this.axiosIns.get(`${this.serviceConfig.reconciliationService}/providers`, {
      params: args
    });
  }

  getProviderBillingStatus(id) {
    return this.axiosIns.get(
      `${this.serviceConfig.reconciliationService}/provider-billings/${id}/status`
    );
  }

  triggerReconciliation(payload) {
    return this.axiosIns.post(
      `${this.serviceConfig.reconciliationService}/reconciliation-processing/trigger`,
      payload
    );
  }
}
